import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

const useScrollIntoItem = (deps: any) => {
  const { class_topic_content_id, class_topic_id } =
    useParams<{ class_topic_content_id: string; class_topic_id: string }>();

  useEffect(() => {
    if (!class_topic_content_id) return;

    const contentDiv = document.getElementById(
      `${class_topic_id}/${class_topic_content_id}`,
    );
    contentDiv?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, [deps]);

  return null;
};

export default useScrollIntoItem;
